<script>
import { Line } from 'vue-chartjs'
import { hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'

export default {
  extends: Line,
  props: {
    titles: {
      type: Array,
      required: true
    },
    labels: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    max: {
      type: Number
    },
    stepSize: {
      type: Number
    },
    height: {
      type: String,
      default: '300'
    },
    showTicks: {
      type: Boolean,
      default: true
    },
    format: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.renderChart({
      labels: this.labels,
      datasets: [
        {
          label: this.titles[0],
          backgroundColor: hexToRgba(this.getColorByIndex(0), 10),
          borderColor: this.getColorByIndex(0),
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: this.data[0]
        },
        {
          label: this.titles[1],
          backgroundColor: hexToRgba(this.getColorByIndex(1), 10),
          borderColor: this.getColorByIndex(1),
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: this.data[1]
        },
        {
          label: this.titles[2],
          backgroundColor: hexToRgba(this.getColorByIndex(2), 10),
          borderColor: this.getColorByIndex(2),
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: this.data[2]
        },
        {
          label: this.titles[3],
          backgroundColor: hexToRgba(this.getColorByIndex(3), 10),
          borderColor: this.getColorByIndex(3),
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: this.data[3]
        },
        {
          label: this.titles[4],
          backgroundColor: hexToRgba(this.getColorByIndex(4), 10),
          borderColor: this.getColorByIndex(4),
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: this.data[4]
        },
        {
          label: this.titles[5],
          backgroundColor: hexToRgba(this.getColorByIndex(5), 10),
          borderColor: this.getColorByIndex(5),
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: this.data[5]
        },
        {
          label: this.titles[6],
          backgroundColor: hexToRgba(this.getColorByIndex(6), 10),
          borderColor: this.getColorByIndex(6),
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: this.data[6]
        },
        {
          label: this.titles[7],
          backgroundColor: hexToRgba(this.getColorByIndex(7), 10),
          borderColor: this.getColorByIndex(7),
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: this.data[7]
        },
        {
          label: this.titles[8],
          backgroundColor: hexToRgba(this.getColorByIndex(8), 10),
          borderColor: this.getColorByIndex(8),
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: this.data[8]
        },
        {
          label: this.titles[9],
          backgroundColor: hexToRgba(this.getColorByIndex(9), 10),
          borderColor: this.getColorByIndex(9),
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: this.data[9]
        },
      ],
    }, {
      tooltips: {
        mode: 'x',
        callbacks: {
          label: (tooltipItem, data) => {
            if (this.format) {
              return ` ${data.datasets[tooltipItem.datasetIndex].label}: ${this.formatAmount(tooltipItem.yLabel)}`
            } else {
              return ` ${data.datasets[tooltipItem.datasetIndex].label}: ${tooltipItem.yLabel}`
            }
          }
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            callback: (value) =>  {
              if (this.formatAmount(value) !== 0) {
                return this.formatAmount(value)
              } else {
                return value
              }
            }
          },
          display: this.showTicks
        }]
      },
      legend: {
        display: false
      },
      maintainAspectRatio: false,
      yAxes: [{
        ticks: {
          beginAtZero: true,
          stepSize: this.stepSize,
          max: this.max
        },
        gridLines: {
          display: true
        }
      }],
      elements: {
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      }
    })
  }
}
</script>
